import React from "react";

function History({ text, language, calle }) {
  return (
    <div>
      <h2>{text[language].history}</h2>
      <p>{text[language].historyTextP1}</p>
      <div
        className="houses-img-div"
        style={{ backgroundImage: `url(${calle})` }}
      ></div>
      <p className="topic-bottom">{text[language].historyTextP2}</p>
    </div>
  );
}

export default History;
